export const specialities = [
    "Acupuncturist",
    "Acute Care",
    "Addiction (Substance Use Disorder)",
    "Adult Companion",
    "Advanced Practice Dental Therapist",
    "Advanced Practice Midwife",
    "Air Carrier",
    "Allergy & Immunology",
    "Alzheimer Center (Dementia Center)",
    "Ambulance",
    "Anaplastologist",
    "Anesthesiologist Assistant",
    "Anesthesiology",
    "Art Therapist",
    "Assistant Behavior Analyst",
    "Assistant, Podiatric",
    "Assisted Living Facility",
    "Audiologist",
    "Audiologist-Hearing Aid Fitter",
    "Behavior Analyst",
    "Behavior Technician",
    "Blood Bank",
    "Bus",
    "Case Management",
    "Case Manager/Care Coordinator",
    "Chiropractor",
    "Chore Provider",
    "Chronic Disease Hospital",
    "Clinic/Center",
    "Clinical Ethicist",
    "Clinical Exercise Physiologist",
    "Clinical Medical Laboratory",
    "Clinical Neuropsychologist",
    "Clinical Nurse Specialist",
    "Clinical Pharmacology",
    "Colon & Rectal Surgery",
    "Community Based Residential Treatment Facility, Intellectual and/or Developmental Disabilities",
    "Community Based Residential Treatment Facility, Mental Illness",
    "Community Health Worker",
    "Community/Behavioral Health",
    "Contractor",
    "Counselor",
    "Custodial Care Facility",
    "Dance Therapist",
    "Day Training, Developmentally Disabled Services",
    "Day Training/Habilitation Specialist",
    "Dental Assistant",
    "Dental Hygienist",
    "Dental Laboratory",
    "Dental Laboratory Technician",
    "Dental Therapist",
    "Dentist",
    "Denturist",
    "Department of Veterans Affairs (VA) Pharmacy",
    "Dermatology",
    "Developmental Therapist",
    "Dietary Manager",
    "Dietetic Technician, Registered",
    "Dietitian, Registered",
    "Doula",
    "Drama Therapist",
    "Driver",
    "Durable Medical Equipment & Medical Supplies",
    "Early Intervention Provider Agency",
    "Electrodiagnostic Medicine",
    "Emergency Medical Technician, Basic",
    "Emergency Medical Technician, Intermediate",
    "Emergency Medical Technician, Paramedic",
    "Emergency Medicine",
    "Emergency Response System Companies",
    "Epilepsy Unit",
    "Exclusive Provider Organization",
    "Eye Bank",
    "Eyewear Supplier",
    "Family Medicine",
    "Foster Care Agency",
    "Funeral Director",
    "General Acute Care Hospital",
    "General Practice",
    "Genetic Counselor, MS",
    "Health & Wellness Coach",
    "Health Educator",
    "Health Maintenance Organization",
    "Hearing Aid Equipment",
    "Hearing Instrument Specialist",
    "Home Delivered Meals",
    "Home Health",
    "Home Health Aide",
    "Home Infusion",
    "Homemaker",
    "Homeopath",
    "Hospice Care, Community Based",
    "Hospice, Inpatient",
    "Hospitalist",
    "In Home Supportive Care",
    "Independent Medical Examiner",
    "Indian Health Service/Tribal/Urban Indian Health (I/T/U) Pharmacy",
    "Intermediate Care Facility, Mental Illness",
    "Intermediate Care Facility, Mentally Retarded",
    "Internal Medicine",
    "Interpreter",
    "Kinesiotherapist",
    "Lactation Consultant, Non-RN",
    "Legal Medicine",
    "Licensed Practical Nurse",
    "Licensed Psychiatric Technician",
    "Licensed Vocational Nurse",
    "Local Education Agency (LEA)",
    "Lodging",
    "Long Term Care Hospital",
    "Marriage & Family Therapist",
    "Massage Therapist",
    "Mastectomy Fitter",
    "Meals",
    "Mechanotherapist",
    "Medical Foods Supplier",
    "Medical Genetics",
    "Medical Genetics, Ph.D. Medical Genetics",
    "Medicare Defined Swing Bed Unit",
    "Midwife",
    "Midwife, Lay",
    "Military Clinical Medical Laboratory",
    "Military Health Care Provider",
    "Military Hospital",
    "Military/U.S. Coast Guard Pharmacy",
    "Military/U.S. Coast Guard Transport",
    "Multi-Specialty",
    "Music Therapist",
    "Naprapath",
    "Naturopath",
    "Neurological Surgery",
    "Neuromusculoskeletal Medicine & OMM",
    "Neuromusculoskeletal Medicine, Sports Medicine",
    "Non-emergency Medical Transport (VAN)",
    "Non-Pharmacy Dispensing Site",
    "Nuclear Medicine",
    "Nurse Anesthetist, Certified Registered",
    "Nurse Practitioner",
    "Nurse's Aide",
    "Nursing Care",
    "Nursing Facility/Intermediate Care Facility",
    "Nursing Home Administrator",
    "Nutritionist",
    "Obstetrics & Gynecology",
    "Occupational Therapist",
    "Occupational Therapy Assistant",
    "Ophthalmology",
    "Optometrist",
    "Oral & Maxillofacial Surgery",
    "Oral Medicinist",
    "Organ Procurement Organization",
    "Orthopaedic Surgery",
    "Orthotic Fitter",
    "Orthotist",
    "Otolaryngology",
    "Pain Medicine",
    "Pathology",
    "Pediatrics",
    "Pedorthist",
    "Peer Specialist",
    "Perfusionist",
    "Personal Emergency Response Attendant",
    "Pharmacist",
    "Pharmacy",
    "Pharmacy Technician",
    "Phlebology",
    "Physical Medicine & Rehabilitation",
    "Physical Therapist",
    "Physical Therapy Assistant",
    "Physician Assistant",
    "Physiological Laboratory",
    "Plastic Surgery",
    "Podiatrist",
    "Poetry Therapist",
    "Point of Service",
    "Portable X-ray and/or Other Portable Diagnostic Imaging Supplier",
    "Preferred Provider Organization",
    "Prevention Professional",
    "Preventive Medicine",
    "Private Vehicle",
    "Program of All-Inclusive Care for the Elderly (PACE) Provider Organization",
    "Prosthetic/Orthotic Supplier",
    "Prosthetist",
    "Psychiatric Hospital",
    "Psychiatric Residential Treatment Facility",
    "Psychiatric Unit",
    "Psychiatry & Neurology",
    "Psychoanalyst",
    "Psychologist",
    "Public Health or Welfare",
    "Pulmonary Function Technologist",
    "Radiologic Technologist",
    "Radiology",
    "Radiology Practitioner Assistant",
    "Recreation Therapist",
    "Recreational Therapist Assistant",
    "Reflexologist",
    "Registered Nurse",
    "Rehabilitation Counselor",
    "Rehabilitation Hospital",
    "Rehabilitation Practitioner",
    "Rehabilitation Unit",
    "Rehabilitation, Substance Use Disorder Unit",
    "Religious Nonmedical Health Care Institution",
    "Religious Nonmedical Nursing Personnel",
    "Religious Nonmedical Practitioner",
    "Residential Treatment Facility, Emotionally Disturbed Children",
    "Residential Treatment Facility, Intellectual and/or Developmental Disabilities",
    "Residential Treatment Facility, Physical Disabilities",
    "Respiratory Therapist, Certified",
    "Respiratory Therapist, Registered",
    "Respite Care",
    "Secured Medical Transport (VAN)",
    "Single Specialty",
    "Skilled Nursing Facility",
    "Sleep Specialist, PhD",
    "Social Worker",
    "Special Hospital",
    "Specialist",
    "Specialist/Technologist",
    "Specialist/Technologist Cardiovascular",
    "Specialist/Technologist, Health Information",
    "Specialist/Technologist, Other",
    "Specialist/Technologist, Pathology",
    "Speech-Language Pathologist",
    "Student in an Organized Health Care Education/Training Program",
    "Substance Abuse Rehabilitation Facility",
    "Supports Brokerage",
    "Surgery",
    "Taxi",
    "Technician",
    "Technician, Cardiology",
    "Technician, Health Information",
    "Technician, Other",
    "Technician, Pathology",
    "Technician/Technologist",
    "Thoracic Surgery (Cardiothoracic Vascular Surgery)",
    "Train",
    "Transplant Surgery",
    "Transportation Broker",
    "Transportation Network Company",
    "Urology",
    "Veterinarian",
    "Voluntary or Charitable"
];
